import React, { useEffect } from "react";
import Breadcrumbs from "../../common/breadcrumbs";
import AOS from "aos";
import "aos/dist/aos.css";

const TermsCondition = () => {
    const htmlContent = `<p>Please note the following Terms and Conditions apply to bookings placed directly on the NAMO CARS website or through an affiliate website. Throughout this document, Namo Cars will be referred to as 'the company' after the first mention.</p>
<p>The terms and conditions of the company are the policies that govern the relationship between the Company and the User. These terms and conditions (as amended from time to time including all Schedules and Annexures hereto) shall constitute a legally valid and binding contract under the Applicable Laws and the use of any product Services either through Namo Cars Website by the User shall be deemed to be an acceptance of all the terms and conditions set forth herein. Users are advised to read these terms and conditions carefully before using/registering on the Website/ App or availing Services through the same. Namo Cars reserves the right to alter/modify/change these terms and conditions in its sole discretion, from time to time, with or without prior notice to the User. Notice of any changes shall be made by Namo Cars, promptly and communicated/brought to the attention of the User in such manner as it deems fit.</p>
<h2><strong>Requirements to Rent </strong></h2>
<p><strong>You must bring the following items to collect your car:</strong></p>
<ul>
<li>A valid original Indian driving license with at least 2 years of driving experience is required. The driver must be 21 years or older.</li>
<li>Proof of address such as Aadhar Card, utility bill - must match address on license.</li>
<li>Namo Cars Booking Voucher (paper or digital)</li>
</ul>
<p><strong>Driver License Requirements</strong></p>
<ol>
<li>Drivers must bring previous driving licenses or a letter from their driving license authority stating that they have held it for at least the minimum period if their current driving license does not show the full period.</li>
<li>Digital Driving licenses are not accepted; a physical driving license is required.</li>
<li>For customers who do not hold an Indian driver's license, it is mandatory to present the driving license issued by their country (the license must be in Roman letters or the Latin alphabet) along with a valid International Driving Permit (IDP).</li>
<li>Exclusions will apply with regards to traffic violations or penalty points. Any offences relating to drink or drug usage (however old) may result in no car being offered.</li>
<li>Vehicles used for customer and reward are excluded from the insurance policy.</li>
<li>Customers must ensure that their current home address is showing on the rental agreement.</li>
<li>For security reasons name changes are not allowed.</li>
<li>It is the customer's responsibility to ensure that their license is valid for use in India. Failure to provide a valid license and permit (where required) will result in a non-refundable cancellation of the registration.</li>
</ol>
<p><strong>[A photograph of drivers is required for insurance formalities and will be taken at the time of rental. In keeping with privacy legislation, the image will not be shared outside the company or its insurer unless illegal activity is suspected, at which point it could be shared with Police or a duly authorized enforcement body.]</strong></p>
<p>You may be denied rental for reasons including:</p>
<ul>
<li>Previous driving disqualifications</li>
<li>Pending prosecution or police enquiry</li>
<li>Convictions for offences relating to theft, fraud or dishonesty</li>
<li>Involvement in an at-fault accident within the last 5 years</li>
<li>Involvement in more than one accident in the last 3 years</li>
<li>Defective vision</li>
<li>The company reserves the right to cancel the booking at the time of delivery if any suspicious activity or irregularity is observed. The decision of the company in such matters shall be final and binding.</li>
</ul>
<p><strong>Accepted Methods of Payments and Preauthorization of Deposits</strong></p>
<table>
<thead>
<tr>
<td>
<p>The company accept credit cards for payment as detailed below. All credit card payments will be subject to and must pass PIN verification. Cards must be in the main driver's name.</p>
</td>
</tr>
<tr>
<td>
<table>
<tbody>
<tr>
<td>
<p><strong>Method of Payment</strong></p>
</td>
<td>
<p><strong>Accepted for local Rental Charges</strong></p>
</td>
<td>
<p><strong>Accepted for Security Deposit</strong></p>
</td>
</tr>
<tr>
<td>
<p>Credit Card (VISA / Mastercard)</p>
</td>
<td>
<p>YES</p>
</td>
<td>
<p>YES</p>
</td>
</tr>
<tr>
<td>
<p>Debit Card</p>
</td>
<td>
<p>YES</p>
</td>
<td>
<p>YES</p>
</td>
</tr>
<tr>
<td>
<p>Cash/Cheques</p>
</td>
<td>
<p>No</p>
</td>
<td>
<p>NO</p>
</td>
</tr>
<tr>
<td>
<p>Virtual Cards (E.G Apple Pay/Google Pay)</p>
</td>
<td>
<p>YES</p>
</td>
<td>
<p>YES</p>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</thead>
</table>
<table>
<tbody>
<tr>
<td>
<p><strong>Convenience Fee</strong></p>
</td>
</tr>
<tr>
<td>
<p>A convenience fee is levied by our payment gateway provider on every transaction made through our website, Namo Cars. The convenience fee is charged by our payment gateway provider, and not by Namo Cars. The fee is clearly displayed on the payment page before the user makes the payment..By using our website and making online payments, you agree to pay the convenience fee levied by our payment gateway provider and accept the terms and conditions.</p>
</td>
</tr>
</tbody>
</table>
<p><strong>Booking Voucher</strong></p>
<p>A printed or electronic copy of your voucher is required to confirm your booking details upon arrival at the rental desk.</p>
<p><strong>Pricing</strong></p>
<p>The company website offers multi-pricing packages with differing inclusions and deposit/excess amounts. Details of each package will be available during booking and on the rental voucher. The customer is responsible for checking package inclusions before booking.</p>
<p><strong>FUEL CHARGES</strong></p>
<p>Vehicles are supplied without fuel. You must maintain the same fuel level at delivery when returning the vehicle. If fuel is lower at drop off, you can top up or pay the fuel cost used. There is no option to refund or adjust extra fuel filled. Customers should not fill more than their expected usage.</p>
<p><strong>EXTRA KMS CHARGES:</strong></p>
<p>You can select various per-day KM options under our packages. If you exceed the total allowed kilometers, extra charges will apply based on vehicle type.</p>
<p><strong>Roadside Assistance</strong></p>
<p>Manufacturer's warranty roadside assistance is included. Relevant contact details and procedures will be provided before rental commences. The company reserves the right not to provide a replacement vehicle depending on circumstances. The company does not take liability for driver error faults, only provides free recovery or other solution for immobility.</p>
<p>Breakdown costs related to misuse/sympathetic use of vehicle are not covered and will incur charges.</p>
<p><strong>Smoking Policy</strong></p>
<p>It is illegal to smoke in a rental vehicle. If you have smoked or allowed smoking within the vehicle, charges up to the full excess will apply. This includes allowing cigarette (or cigar) smoke or ash into the vehicle, implying the above.</p>
<p><strong>Deposit Refund Policy:&nbsp;</strong><strong>We have a transparent refund policy. We will refund your security deposit within 48 Business hours after that bank takes sometime</strong></p>
<p><strong>Valeting Vehicles</strong></p>
<p>If a vehicle is returned unclean internally/externally requiring more than standard clean, a valeting charge of INR 500 will apply. Hazardous or excessive soiling requiring specialist cleaning will be charged per the specialist required.</p>
<p><strong>Delayed Pick-ups/ No show policy</strong></p>
<p><strong>AT AIRPORT LOCATIONS:</strong></p>
<ul>
<li>Registration will be held for 4 hours within office hours from the specified time, after which a no-show will be assumed. If customer arrives after this time, a vehicle is not assured. Pick-ups outside office hours incur an 'Out of Hours' fee.</li>
<li>For flight delays with a valid flight number, registration will be held for 4 hours from the delayed arrival time within office hours. Collection outside office hours incurs an 'Out of Hours' fee by prior arrangement. It is the customer's responsibility to inform the location before flying if arriving after closing, as soon as possible.</li>
<li>If no valid flight number is provided, registration will be held for 4 hours or until location closes. Staff cannot wait after closing when no flight number is provided.</li>
<li>Flight diversions will be treated as a no-show at the original location and transfer cannot be assumed.</li>
</ul>
<p><strong>AT NON-AIRPORT LOCATIONS:</strong></p>
<ul>
<li>Registration will be held for 4 hours or until closing office time, whichever comes first. Staff will not wait after closing time.</li>
</ul>
<p>The company will make every effort to provide a vehicle, which may involve offering a different vehicle at different rates to the original booking.</p>
<p>Late pick-ups outside office hours may incur the 'Out of Hours' fee. Requests via email cannot be guaranteed.</p>
<p>No refunds given for rentals ended early, late pick-ups, no-shows or cancellations after the rental start date.</p>
<p><strong>Lost Keys</strong></p>
<p>A charge will apply for lost or damaged keys. Note that if a vehicle is stolen and keys not returned, the customer will be deemed negligent, liable for all recovery, loss of use and repair costs. This list is not exhaustive.</p>
<p><strong>Rental Extensions</strong></p>
<p>Extensions may not always be possible at the hiring branch. Where agreed, the extension will be charged at the prevailing rate which may differ from the original booking rate.</p>
<p><strong>Un-authorized Rental Extension</strong></p>
<p>This occurs when the customer fails to return the vehicle within the agreed return date, time and location on the contract. This will be a breach of contract and incur charges including reverting to 'Rack Rate' costs:</p>
<p>Namo Cars Rack Rate Tariff: 2 times the per day rental rate of that vehicle.</p>
<p><strong>Early Drop off/Unused Rental Days</strong></p>
<p>No refunds given for rentals ended early, including purchase of ancillary items, late pick-ups, extensions, no shows or cancellations after the rental start date.</p>
<p><strong>Late Drop off</strong></p>
<p>A grace period applies as detailed in the rental agreement. After this, the booking will be classed as late and additional charges will be due. The minimum charge is&nbsp;<strong>INR 500/- per hour</strong>&nbsp;but may vary according to the vehicle's rental value. The company will attempt to inform you of costs.</p>
<p>Any optional extras like additional drivers or waivers already taken will be charged. The charge will be applied to the card used for security deposit.</p>
<p>Late drop offs after the grace period are considered unauthorized extensions without written approval from the rental location.</p>
<p><strong>Grace period: 39 minutes</strong></p>
<p>&nbsp;<strong>Amendments</strong><br/>All changes to bookings must be requested in writing by email at least 24 hours before the rental start time. Telephone requests will not be accepted. Any change may be treated as a new booking.</p>
<p><strong>Fines, Penalties and Administration Charges</strong><br/>The customer is fully responsible for all parking fines, traffic violations, penalties, and related charges. If the company processes or pays any such amount on behalf of the customer, the full amount shall be recovered from the customer without limitation, together with applicable administrative costs, including fines or notices received after the booking period.</p>
<p><strong>Traffic / Parking Violations</strong><br/>Customers must pay all traffic fines and late fees, even if the notice arrives after the booking ends. Proof of payment (receipt) must be sent to us immediately. If not, an additional charge of INR 500 per case will apply.</p>
<p>&nbsp;Over-speeding above <strong>80 km/h</strong> will attract a penalty of <strong>INR 1000 for each event</strong>, as recorded by the government-approved GPS device fitted in the vehicle. On certain roads where the legal speed limit is higher (e.g., 100 km/h or 110 km/h), the customer must follow the applicable road speed limit. If the customer violates the prescribed speed limit of that road, they shall be liable to pay the fine/penalty as applicable in addition to company charges.</p>
<p>&nbsp;<strong>Toll / Parking</strong><br/>Customers are responsible for all toll and parking charges incurred during the rental period, including airport parking fees. Any tolls or parking fees used or paid by the customer must be borne entirely by the customer</p>
<p><strong>Opening Hours</strong></p>
<p>Location opening hours can be found on&nbsp;<a href="http://www.namocars.com">www.namocars.com</a>. The customer is responsible to check the location's operational hours, along with any national or public holiday closures.</p>
<p><strong>Downtime charges:</strong></p>
<ol>
<li><strong>Limited liability</strong></li>
</ol>
<p>In the event of damages, Customer liability is limited to a maximum of Rs 1,00,000. Customers will need to pay a Damage Fee equivalent to the repair cost (as estimated given by a Namo Cars) and downtime losses, up to a maximum of Rs1,00,000. The decision of Namo Cars in terms of assessment of the damage and any incidental costs and taxes shall be binding on the Customer and the Customer agrees to pay the same without any dispute or delay.<br/>Please note that the maximum liability policy is intended to benefit and protect the responsible user. In situations of irresponsible or unsafe or negligent usage, there could be discretionary exceptions to this policy, whereby the user could be liable for all damages irrespective of whether or not Namo Cars is able to claim insurance in such cases.</p>
<p>Please note that the maximum liability policy is intended to benefit and protect the responsible user. Customer can book another vehicle online through our website, as a new booking completing all the formalities and payments. Customer can pick up the second vehicle after assuring that, all the procedures as advised by our operations team are completed and the damaged vehicle is returned to the company.</p>
<p><strong>Complaints</strong></p>
<p>Please send copies of all correspondence with the branch and any other supporting documents to <a href="mailto:namocars16@gmail.com">namocars16@gmail.com</a>&nbsp;</p>
<p>Any complaints should be made via email within 30 days of the return date. Complaints received after this period may not be considered.</p>
<h2><strong>Cancellation Policy</strong></h2>
<p>&nbsp;<strong>CANCELLATION CHARGES:</strong></p>
<ul>
<li>15% - for cancellation before 48 hours from the start time</li>
<li>30% - for cancellation before 24 hours and less than 48 hours from the start time</li>
<li>60% - for cancellation before 10 hours and less than 24 hours from the start time</li>
<li>80% - for cancellation before 2 hours and less than 10 hours from the start time</li>
<li>100% - for cancellation in less than 2 hours from the start time</li>
</ul>
<p><strong>Enrollment as a user:</strong></p>
<ul>
<ul>
<ul>
<li>By accepting these Terms and Conditions, the User has agreed to enroll as a User under the Scheme to avail the facility for rental of Namo Cars Vehicles.</li>
<li>The User further acknowledges and understands that he/she shall not at any time challenge any of the provisions of these Terms or the contents of the Website on the premise that the terms and conditions have not been read by the User or that the User is not aware of the enrolment formalities or that the User has not understood any provision of these Terms or the procedures, formalities, benefits rights and/or obligations as contained on the Website.</li>
<li>There is no difference between User &amp; Customer. A user is a person who registered with namocars.com and a customer is a person who hired the vehicle.</li>
<li>Before taking Namo Cars it's your responsibility take pictures &amp;vedios. Incase Namo Cars claims for any damage client need to proof from their pictures.&nbsp;</li>
</ul>
</ul>
</ul>`; // fixed closing tag

    useEffect(() => {
        AOS.init({ duration: 1200, once: true });
    }, []);

    return (
        <div className="main-wrapper">
            <Breadcrumbs title="Terms & Conditions" subtitle="Pages" />

            <div className="privacy-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div
                                className="terms-policy"
                                dangerouslySetInnerHTML={{ __html: htmlContent }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsCondition;
